<template>
  <div class="form-select">
    <label for="showing" class="label">{{label}}</label>
    <b-form-select v-model="optionValue" class="col-8">
      <option :value="defaultFilterOption">{{defaultFilterOption.name}}</option>
      <option :value="item" v-for="item in filterItems" v-bind:key="item.id">{{item.name}}</option>
    </b-form-select>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      require: true,
      defailt: () => ''
    },
    defaultFilterOption: {
      type: Object,
      required: true,
      default: () => {}
    },
    filterItems: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  computed: {
    optionValue: {
      get: function () {
        return this.defaultFilterOption
      },
      set: function (value) {
        this.$emit('valuechange', value)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.form-select {
  margin: auto;
  font-weight: 600;
  letter-spacing: 0.75px;

  .custom-select {
    border: none;
    background-color: $color-body-bg;
    font-weight: 600;
    letter-spacing: 0.75px;
    &:focus {
      outline: none;
      box-shadow: none;
    }
  }
}
</style>
